/***
 * Created on 2023/10/12
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useEffect} from 'react';
import {useTranslation} from "react-i18next";
import img_mail_svg from '../../static/img/utils/ic--2-step-method--mail.svg';
import img_mobile_svg from '../../static/img/utils/ic--2-step-method--sms.svg';
import totp_svg from '../../static/img/utils/ic-2-step-method--totp.svg';
import qrcode_svg from '../../static/img/utils/ic-2-step-method--qrcode.svg';
import approval_svg from '../../static/img/utils/ic-2-step-method--login-approve.svg';
import verify_svg from '../../static/img/utils/ic-2-step-method--online-verification-code.svg';
import VerifyMethodItem from "./verify_method_item";
import {useQuery} from "@tanstack/react-query";
import {apiGet} from "../../service/api";
import {useCountdown} from "../../hook/countdown";


function OtherWaysComponent({goBack, setMethod, defaultMethod, user, email, sendTwoStepCode}) {
    const { t } = useTranslation();
    const {seconds, setSeconds} = useCountdown(0);

    const resendTwoStep = async (send_type) => {
        await sendTwoStepCode(send_type);
        setMethod(send_type);
        goBack();
    }

    const {data, isSuccess} = useQuery({
        queryKey: ['get_countdown'],
        queryFn: async () => await apiGet('/ajax/countdown')
    });

    useEffect(() => {
        if (data && isSuccess) {
            const now = new Date().getTime();
            const value = Math.round((now - data?.countdown) / 1000) || 0;
            setSeconds(value > 60 ? 0 : 60 - value);
        }
    }, [data, isSuccess]);

    return (
        <>
            <div className="common-page-body">
                { seconds > 0 &&
                    <div className="common-info-grid alert-content--info !display-style--info mb-24">
                        <div className="common-info-grid__row common-info-grid__row--cd-banner">
                            <div className="common-info-grid__row--cd-banner__info">
                                {t('@You can click the following action once the counter dismisses.@')}
                            </div>
                            <div className="common-info-grid__row--cd-banner__cd">
                                <span className="text-18">{seconds}</span>
                                <span className="text-15">s</span>
                            </div>
                        </div>
                    </div>
                }

                <p>{t('@To Sign in your QID account, choose a phone from the list below@')}:</p>

                {
                    user?.secure?.google_auth && user?.secure?.two_step_enabled &&
                    <VerifyMethodItem onClickAction={()=>resendTwoStep("google_auth")} image={totp_svg} isDisable={false} description={t('@Generate a verification code using your authenticator app@')}/>
                }
                {
                    user?.secure?.qnap_auth?.settings.method['qrcode'].enabled && user?.secure?.two_step_enabled &&
                    <VerifyMethodItem onClickAction={()=>resendTwoStep("qrcode")} image={qrcode_svg} isDisable={false} description={t('@Scan the QR code with your "QNAP Authenticator" to log in@')}/>
                }
                {
                    user?.secure?.qnap_auth?.settings.method['approval'].enabled && user?.secure?.two_step_enabled &&
                    <VerifyMethodItem onClickAction={()=>resendTwoStep("approval")} image={approval_svg} isDisable={false} description={t('@Approve the request with the "QNAP Authenticator" app@')}/>
                }
                {
                    user?.secure?.qnap_auth?.settings.method['verification'].enabled && user?.secure?.two_step_enabled &&
                    <VerifyMethodItem onClickAction={()=>resendTwoStep("verification")} image={verify_svg} isDisable={false} description={t('@Get a verification code with your QNAP Authenticator@')}/>
                }
                {
                    user?.secure?.sms_1 &&
                    <VerifyMethodItem onClickAction={()=>resendTwoStep("sms_1")} image={img_mobile_svg} isDisable={seconds > 0} description={`${t('@Send a verification code to your phone number@')} ${user?.secure?.sms_1?.phone_number}`}/>
                }
                {
                    user?.secure?.sms_2 &&
                    <VerifyMethodItem onClickAction={()=>resendTwoStep("sms_2")} image={img_mobile_svg} isDisable={seconds > 0} description={`${t('@Send a verification code to your phone number@')} ${user?.secure?.sms_2?.phone_number}`}/>
                }
                {
                    email &&
                    <VerifyMethodItem onClickAction={()=>resendTwoStep("email")} image={img_mail_svg} isDisable={seconds > 0} description={`${t('@Send a verification code to your QID email account@')} ${email}`}/>
                }
            </div>
            <div className="common-page-footer">
                <div className="q-btn-group btn-align-right">
                    <button className="q-btn q-btn--default btn-medium btn-rounded-normal" onClick={goBack}>{t('@Back@')}</button>
                </div>
            </div>
        </>
    );
}

export default OtherWaysComponent;